import React from 'react'
import { FaMapMarkedAlt } from 'react-icons/fa';
import { AiOutlinePhone, AiOutlineMail } from 'react-icons/ai';
import { IconContext } from 'react-icons';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="w-full text-white  bg-[url('./images/footer.jpg')] bg-center bg-no-repeat bg-cover pt-[10em]" >
            <div className='grid grid-cols-1 place-items-stretch md:grid-cols-3 pt-16 md:px-24 bg-black opacity-85'>

                <div className='mx-4 md:mx-0'>
                    <Link to="/"> <img src="images/logow.png" alt="" width="200px" className='' /></Link>
                    <p className=' mt-6'>
                        Votre quai mérite notre expertise – contactez-nous.
                    </p>

                    {/* <div className='flex mr-8 p-8 box-contact-icon'>
                    <a href=''> <AiFillFacebook className='text-3xl  text-rcblue' /> </a> 
                    <a href=''> <AiFillInstagram className='text-3xl  text-rcblue' /> </a> 
                </div> */}
                </div>

                <div className='mt-10 md:ml-36 md:mt-0'>
                    <h5 className='subtitlel uppercase relative pb-2 text-3xl ml-4'>Nos services</h5>
                    <ul className='ml-4'>
                        <li>Quais sur poteaux</li>
                        <li>Quais flottants</li>
                        <li>Accès au lac</li>
                        <li>Au-dessus de l’eau</li>
                        <li>De tout pour vous!</li>

                    </ul>

                </div>

                <div className=' mt-10 md:mt-0 md:m-auto'>
                    <h5 className='subtitlel uppercase relative pb-2 text-3xl ml-4'>Contactez-nous</h5>
                    <IconContext.Provider value={{ size: '35', color: '#ffffff' }}>

                        <ul className='ml-4'>
                            <li className='flex items-center'>

                                <div className=' text-center mr-4'>

                                    <FaMapMarkedAlt />

                                </div>

                                <div>
                                    220, Chemin Galipeau, Ascot Corner<br /> (Québec) J0B 1A0
                                </div>
                            </li>

                            <li className='flex items-center mb-4'>

                                <div className=' text-center mr-4'>

                                    <AiOutlinePhone />

                                </div>

                                <div>
                                    <a className="nav-link" href="tel:8198225760">(819)822-5760</a>,<br />
                                    <a className="nav-link" href="tel:8196743090">(819)674-3090</a>
                                </div>
                            </li>

                            <li className='flex items-center mb-4'>

                                <div className=' text-center mr-4'>

                                    <AiOutlineMail />

                                </div>

                                <div>
                                    <a className="nav-link" href="email:quaisdanroc@videotron.ca">quaisdanroc@videotron.ca</a>
                                </div>
                            </li>

                        </ul>
                    </IconContext.Provider>
                </div>
            </div>



        </footer>
    )
}

export default Footer